import config from "../../config";
import _ from "underscore";
import {extractProductIdFromStoreFrontId, getShopifyProductUrl, productTagsGraphToArray} from "./utils";
import moment from "moment";

export const ProductModel = (product, selectedCountry, init) => {
    const pdp_field_mapping = init?.pdp_field_mapping || [];
    const plp_size_tag_prefix = init?.plp_size_tag_prefix || null;
    const extra_tags_prefix = init?.extra_tags_prefix || null;
    const wholesaleDiscountsFilterObj = config.wholesaleDiscountsFilters;
    const updatedImages = [];
    const images_info = [];
    const {id, handle, vendor, images, variants, title, tags, updatedAt, descriptionHtml, productType} = product;

    //we need to map images and images_info from groupBy

    if (product.allMeta) {
        if (product.allMeta.images) {
            product.allMeta.images.forEach((image) => {
                updatedImages.push(image.uri);
                images_info.push({
                    width: image.width,
                    height: image.height,
                    src: image.uri
                })
            })
        }
    }
    let product_overview = {
        condition: {
            position: 10,
            title: "Condition",
            value: null,
            is_overview: false
        },
        condition_specifics: {
            position: 20,
            title: "Condition Specifics",
            value: null,
            is_overview: false
        },
        estimated_retail_price: {
            position: 30,
            title: "Estimated Retail Price",
            value: null,
            is_overview: false
        },
        original_price: {
            position: 160,
            title: "",
            value: null,
            is_overview: false
        }
    }

    _.map(pdp_field_mapping, (pdp_field) => {
        _.map(pdp_field.metafields, (meta_field, idx) => {
            product_overview[meta_field.key] = {
                position: idx * 10,
                title: meta_field.title ? meta_field.title : pdp_field.section_title,
                value: null,
                section: pdp_field.section_title
            }
        })
    })

    const getID = () => {
        return product.item_id
            || (product.allMeta && parseInt(product.allMeta.id))
            || (id && id.toString().includes("gid") && extractProductIdFromStoreFrontId(id))
            || id
            || null;
    }

    const getTags = () => {
        return (tags && tags.length > 0 && _.isString(tags[0]) && tags)
            || (product.allMeta && product.allMeta.attributes && product.allMeta.attributes.tags && product.allMeta.attributes.tags.text)
            || productTagsGraphToArray(tags)
            || [];
    }

    const getImage = () => {
        return (product.images_info && product.images_info.length > 0 && product.images_info[0].src)
            || (product.image && product.image.src)
            || (product_variant && product_variant.image && product_variant.image.src)
            || (product.allMeta && product.allMeta.images && product.allMeta.images[0] && product.allMeta.images[0].uri)
            || (product.images && product.images[0])
            || (product.image_url && product.image_url)
            || null;
    }

    const getPrice = () => {
        return (product_variant && product_variant.priceV2 && parseInt(product_variant.priceV2.amount))
            || (product_variant && product_variant.price && parseInt(product_variant.price))
            || parseInt(product_variant["price_" + selectedCountry?.currency.isoCode.toLowerCase()])
            || product.price
            || (product.allMeta && product.allMeta.priceInfo && product.allMeta.priceInfo.price)
            || 0;
    }

    const getFavCount = () => {
        const favoritesCountObj = _.find(product.metafields, (meta) => {
            return "favorites_count" === meta.namespace && "counter" === meta.key
        });
        return (product.favorites_count && product.favorites_count)
            || (favoritesCountObj && favoritesCountObj.value)
            || product.allMeta?.attributes?.favorites_count?.numbers[0]
            || (product.fav_count && product.fav_count)
            || 0;
    }

    const getMetafields = () => {
        return product.metafields ? product.metafields : product.product_details || product.allMeta?.attributes?.metafields?.text;
    }

    const getVariant = () => {
        return variants ? variants[0] : [];
    }

    const getVariantList = () => {
        return variants && variants.length > 1 ? variants : [];
    }

    const getProductUrl = () => {
        return product.url
            || (product.product_url && product.product_url)
            || getShopifyProductUrl(product);
    }

    const getAvailability = () => {
        return (product && product.availableForSale)
            || (product_variant && product_variant.available)
            || (product.allMeta && product.allMeta.availability === 'IN_STOCK')
            || (product && product.available)
            || (product.availability && product.availability === "in_stock")
            || false;
    }

    const getVendor = () => {
        return vendor
            || (product.allMeta?.brands && product.allMeta.brands[0])
            || product.designer;
    }

    const product_variant = getVariant();
    const product_tags = getTags();
    const product_metafields = getMetafields();

    let parsed_product = {
        id: getID(),
        handle: handle || product.allMeta?.attributes?.handle?.text[0],
        url: getProductUrl(),
        vendor: getVendor(),
        image: getImage(product),
        images: images || updatedImages,
        images_info: images_info,
        title: title || product.allMeta?.title,
        descriptionHtml: descriptionHtml || null,
        price: getPrice(),
        favorites_count: getFavCount(),
        product_details: product_overview,
        availableForSale: getAvailability(),
        product_variant: product_variant,
        product_variants: getVariantList(),
        tags: product_tags,
        updatedAt: moment(updatedAt).format(),
        batch_publish_date: null,
        batch_first_look_ends_at: null,
        size_and_fit_image: null,
        vault_article_link: null,
        is_outlet: false,
        is_man_or_unisex: false,
        is_shoe: false,
        is_apparel: false,
        has_pricedrop_tag: false,
        wholesaleTag: null,
        productTag: null,
        item_type: 'bag',
        item_size: null,
        condition_label: null,
        firstLookProduct: !!product.firstLookProduct,
        has_first_look_tag: false,
        is_most_wanted: false,
    }

    if (product.forYouFilters) {
        parsed_product['forYouFilters'] = product.forYouFilters;
    }

    if(_.isArray(product_tags)){
        product_tags.forEach((tag) => {
            const lower_case_tag = tag.toLowerCase();
            if('outlet' === lower_case_tag){
                parsed_product['is_outlet'] = true;
            } else if('bc-filter-gender-men' === lower_case_tag){
                parsed_product['is_man_or_unisex'] = true;
            } else if('bc-filter-shoes' === lower_case_tag){
                parsed_product['is_shoe'] = true;
            } else if('bc-filter-apparel' === lower_case_tag) {
                parsed_product['is_apparel'] = true;
            } else if('bc-filter-most wanted' === lower_case_tag){
                parsed_product['is_most_wanted'] = true;
            } else if(lower_case_tag.indexOf('item-type-') !== -1){
                parsed_product['item_type'] = tag.replace('item-type-', '');
            } else if(lower_case_tag.indexOf(plp_size_tag_prefix) !== -1){
                parsed_product['item_size'] = tag.replace(plp_size_tag_prefix, '');
            } else if (lower_case_tag.toLowerCase().includes('cl22')) {
                parsed_product['has_pricedrop_tag'] = true;
            } else if (lower_case_tag.search(extra_tags_prefix) !== -1) {
                if ('bc-filter-extra-tags-first look' === lower_case_tag) {
                    parsed_product['has_first_look_tag'] = true;
                }
                parsed_product['productTag'] = tag;
            } else if (_.find(config.conditionList, (config_tag) => { return config_tag.toLowerCase() === lower_case_tag })) {
                parsed_product['condition_label'] = tag.replace("bc-filter-","");
            } else if (_.find(Object.keys(wholesaleDiscountsFilterObj), (wholesaleKey) => { return wholesaleKey.toLowerCase() === lower_case_tag })) {
                parsed_product['wholesaleTag'] = tag;
            }
        })
    }

    if (product_metafields && product_metafields.length > 0) {
        product_metafields.forEach((product_detail) => {
            if (product_detail) {
                const meta_field_key = product_detail.key;
                if (meta_field_key) {
                    let next_value = ["-", "None"].indexOf(product_detail.value) === -1 ? product_detail.value : null;

                    if(['size_and_fit_image', 'vault_article_link'].indexOf(meta_field_key) !== -1){
                        parsed_product[meta_field_key] = next_value;
                    }

                    if(['batch_publish_date', 'batch_first_look_ends_at'].indexOf(meta_field_key) !== -1 && next_value){
                        parsed_product[meta_field_key] = moment(next_value);
                    }

                    if (meta_field_key === 'estimated_retail_price' && next_value) {
                        next_value = (parseFloat(parsed_product.price) / parseFloat(next_value)) < config.hide_estimated_retail_price_below ? next_value : null;
                    }

                    if (["accessories", "size_and_fit", "collateral"].indexOf(meta_field_key) !== -1 && next_value) {
                        next_value = JSON.parse(product_detail.value)[product_detail.key];
                        if (_.isEmpty(next_value)) {
                            next_value = null;
                        }
                    }

                    if (["new_gemstones", "new_pearls"].indexOf(meta_field_key) !== -1 && next_value) {
                        next_value = JSON.parse(next_value);
                        if (_.isEmpty(next_value)) {
                            next_value = null;
                        }
                    }

                    if(['condition'].indexOf(meta_field_key) !== -1 && next_value && !parsed_product['condition_label']){
                        parsed_product['condition_label'] = next_value;
                    }

                    if (next_value && product_overview[meta_field_key]) {
                        product_overview[meta_field_key]['value'] = next_value;
                    }
                } else {
                    const keyValueArray = product_detail.split(":");
                    if (keyValueArray.includes('original_price')) {
                        product_overview['original_price'] = {
                            key: 'original_price',
                            namespace: 'pdp',
                            type: 'single_line_text_field',
                            value: keyValueArray[1],
                        };
                    }
                }
            }
        });

        parsed_product['product_details'] = product_overview;
    }

    if (!parsed_product['condition_label'] && ["-", "None"].indexOf(product.product_details?.condition?.value) === -1) {
        parsed_product['condition_label'] = product.product_details?.condition?.value;
    } else if (!parsed_product['condition_label'] && product.condition) {
        parsed_product['condition_label'] = product.condition;
    }

    return parsed_product;
}